export enum EEmailEventType {
  SuspiciousBehavior = "suspiciousBehavior",
  DigestSummary = "digestSummary",
  SupportTicketCreated = "supportTicketCreated"
}

export interface EmailNotificationRecipient {
  id: string;
  email: string;
  adminId: string | null;
  adminName: string | null;
  eventType: EEmailEventType;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface AdminEmailSuggestion {
  adminId: string;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
}

export interface AddEmailRecipientBody {
  email: string;
  adminId?: string | null;
  eventType: EEmailEventType;
}

export interface GetEmailRecipientsParams
  extends Record<string, string | boolean | undefined> {
  eventType?: EEmailEventType;
  includeInactive?: boolean;
}
